const NO = 'no';

export { NO };
